export default __webpack_public_path__ + "static/camprock-753fe9c709db9b8e8b20b2d55ec2c61d.png";